function createShareUrl({ title, text, url }) {
  if (title) text = title + ' - ' + text
  return `https://www.facebook.com/sharer/sharer.php?quote=${text}&u=${url}`
}

export default {
  id: 'facebook',
  title: 'Facebook',
  createShareUrl
}
